<template>
    <div class="sports">
        <ElementSport v-for="element in sports" :key="element.id" :element="element" />
        <div class="timeline-sports__add" v-if="add" @click="changeState('sports_new')">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 31.444 31.444" style="enable-background:new 0 0 31.444 31.444;" xml:space="preserve" width="512px" height="512px"><g><path d="M1.119,16.841c-0.619,0-1.111-0.508-1.111-1.127c0-0.619,0.492-1.111,1.111-1.111h13.475V1.127  C14.595,0.508,15.103,0,15.722,0c0.619,0,1.111,0.508,1.111,1.127v13.476h13.475c0.619,0,1.127,0.492,1.127,1.111  c0,0.619-0.508,1.127-1.127,1.127H16.833v13.476c0,0.619-0.492,1.127-1.111,1.127c-0.619,0-1.127-0.508-1.127-1.127V16.841H1.119z" data-original="#1E201D" class="active-path" data-old_color="#1E201D" fill="#FFFFFF"/></g></svg>
        </div>
    </div>
</template>
<script>
export default {
    name: 'sports',
    components: {
      ElementSport: () => import('@/components/Filters/ElementSportNew.vue')
    },
    props: {
        sports: {
            type: Array,
            required: true
        },
        add: {
          type: Boolean,
          required: false,
          default: false
        }
    },
    methods: {
      changeState (element) {
        this.$store.dispatch('changeState', {element: element, val: true})
      }
    }
    }
</script>